<template>
  <div class="row">
    <div class="col col-md-11 p-0">
      <div class="card border rounded-3 border-info bg-light">
        <div class="row g-0">
          <div class="col-12 col-md-4 col-lg-5 col-xl-3" id="border">
            <div class="px-4 d-none d-md-block">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <input
                    type="text"
                    class="form-control my-3"
                    placeholder="Search..."
                  />
                </div>
              </div>
            </div>
            <Kullanicilar v-for="i in 10" :key="i" />
          </div>
          <div class="col-12 col-md-8 col-lg-7 col-xl-9">
            <div class="py-2 px-4 border-bottom border-info d-none d-lg-block">
              <div class="d-flex align-items-center py-1">
                <div class="position-relative">
                  <img
                    src="@/assets/avatar.jpg"
                    class="rounded-circle mr-1"
                    alt="Sharon Lessman"
                    width="40"
                    height="40"
                  />
                </div>
                <div class="flex-grow-1 pl-3">
                  <strong>Taha Malaldır</strong>
                  <div class="text-muted small"><em>Typing...</em></div>
                </div>
                <div>
                  <button class="btn btn-light px-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-more-horizontal feather-lg"
                    >
                      <circle cx="12" cy="12" r="1"></circle>
                      <circle cx="19" cy="12" r="1"></circle>
                      <circle cx="5" cy="12" r="1"></circle>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div class="position-relative">
              <div class="chat-messages p-4">
                <div class="chat-message-right pb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar1.png"
                      class="rounded-circle mr-1"
                      alt="Chris Wood"
                      width="40"
                      height="40"
                    />
                    <div class="text-muted small text-nowrap mt-2">2:33 am</div>
                  </div>
                  <div class="flex-shrink-1 bg-light rounded py-2 px-3 mr-3">
                    <div class="font-weight-bold mb-1">You</div>
                    Lorem ipsum dolor sit amet, vis erat denique in, dicunt
                    prodesset te vix.
                  </div>
                </div>

                <div class="chat-message-left pb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar3.png"
                      class="rounded-circle mr-1"
                      alt="Sharon Lessman"
                      width="40"
                      height="40"
                    />
                    <div class="text-muted small text-nowrap mt-2">2:34 am</div>
                  </div>
                  <div class="flex-shrink-1 bg-light rounded py-2 px-3 ml-3">
                    <div class="font-weight-bold mb-1">Sharon Lessman</div>
                    Sit meis deleniti eu, pri vidit meliore docendi ut, an eum
                    erat animal commodo.
                  </div>
                </div>

                <div class="chat-message-right mb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar1.png"
                      class="rounded-circle mr-1"
                      alt="Chris Wood"
                      width="40"
                      height="40"
                    />
                    <div class="text-muted small text-nowrap mt-2">2:35 am</div>
                  </div>
                  <div class="flex-shrink-1 bg-light rounded py-2 px-3 mr-3">
                    <div class="font-weight-bold mb-1">You</div>
                    Cum ea graeci tractatos.
                  </div>
                </div>

                <div class="chat-message-left pb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar3.png"
                      class="rounded-circle mr-1"
                      alt="Sharon Lessman"
                      width="40"
                      height="40"
                    />
                    <div class="text-muted small text-nowrap mt-2">2:36 am</div>
                  </div>
                  <div class="flex-shrink-1 bg-light rounded py-2 px-3 ml-3">
                    <div class="font-weight-bold mb-1">Sharon Lessman</div>
                    Sed pulvinar, massa vitae interdum pulvinar, risus lectus
                    porttitor magna, vitae commodo lectus mauris et velit. Proin
                    ultricies placerat imperdiet. Morbi varius quam ac venenatis
                    tempus.
                  </div>
                </div>

                <div class="chat-message-left pb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar3.png"
                      class="rounded-circle mr-1"
                      alt="Sharon Lessman"
                      width="40"
                      height="40"
                    />
                    <div class="text-muted small text-nowrap mt-2">2:37 am</div>
                  </div>
                  <div class="flex-shrink-1 bg-light rounded py-2 px-3 ml-3">
                    <div class="font-weight-bold mb-1">Sharon Lessman</div>
                    Cras pulvinar, sapien id vehicula aliquet, diam velit
                    elementum orci.
                  </div>
                </div>

                <div class="chat-message-right mb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar1.png"
                      class="rounded-circle mr-1"
                      alt="Chris Wood"
                      width="40"
                      height="40"
                    />
                    <div class="text-muted small text-nowrap mt-2">2:38 am</div>
                  </div>
                  <div class="flex-shrink-1 bg-light rounded py-2 px-3 mr-3">
                    <div class="font-weight-bold mb-1">You</div>
                    Lorem ipsum dolor sit amet, vis erat denique in, dicunt
                    prodesset te vix.
                  </div>
                </div>

                <div class="chat-message-left pb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar3.png"
                      class="rounded-circle mr-1"
                      alt="Sharon Lessman"
                      width="40"
                      height="40"
                    />
                    <div class="text-muted small text-nowrap mt-2">2:39 am</div>
                  </div>
                  <div class="flex-shrink-1 bg-light rounded py-2 px-3 ml-3">
                    <div class="font-weight-bold mb-1">Sharon Lessman</div>
                    Sit meis deleniti eu, pri vidit meliore docendi ut, an eum
                    erat animal commodo.
                  </div>
                </div>

                <div class="chat-message-right mb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar1.png"
                      class="rounded-circle mr-1"
                      alt="Chris Wood"
                      width="40"
                      height="40"
                    />
                    <div class="text-muted small text-nowrap mt-2">2:40 am</div>
                  </div>
                  <div class="flex-shrink-1 bg-light rounded py-2 px-3 mr-3">
                    <div class="font-weight-bold mb-1">You</div>
                    Cum ea graeci tractatos.
                  </div>
                </div>

                <div class="chat-message-right mb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar1.png"
                      class="rounded-circle mr-1"
                      alt="Chris Wood"
                      width="40"
                      height="40"
                    />
                    <div class="text-muted small text-nowrap mt-2">2:41 am</div>
                  </div>
                  <div class="flex-shrink-1 bg-light rounded py-2 px-3 mr-3">
                    <div class="font-weight-bold mb-1">You</div>
                    Morbi finibus, lorem id placerat ullamcorper, nunc enim
                    ultrices massa, id dignissim metus urna eget purus.
                  </div>
                </div>

                <div class="chat-message-left pb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar3.png"
                      class="rounded-circle mr-1"
                      alt="Sharon Lessman"
                      width="40"
                      height="40"
                    />
                    <div class="text-muted small text-nowrap mt-2">2:42 am</div>
                  </div>
                  <div class="flex-shrink-1 bg-light rounded py-2 px-3 ml-3">
                    <div class="font-weight-bold mb-1">Sharon Lessman</div>
                    Sed pulvinar, massa vitae interdum pulvinar, risus lectus
                    porttitor magna, vitae commodo lectus mauris et velit. Proin
                    ultricies placerat imperdiet. Morbi varius quam ac venenatis
                    tempus.
                  </div>
                </div>

                <div class="chat-message-right mb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar1.png"
                      class="rounded-circle mr-1"
                      alt="Chris Wood"
                      width="40"
                      height="40"
                    />
                    <div class="text-muted small text-nowrap mt-2">2:43 am</div>
                  </div>
                  <div class="flex-shrink-1 bg-light rounded py-2 px-3 mr-3">
                    <div class="font-weight-bold mb-1">You</div>
                    Lorem ipsum dolor sit amet, vis erat denique in, dicunt
                    prodesset te vix.
                  </div>
                </div>

                <div class="chat-message-left pb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar3.png"
                      class="rounded-circle mr-1"
                      alt="Sharon Lessman"
                      width="40"
                      height="40"
                    />
                    <div class="text-muted small text-nowrap mt-2">2:44 am</div>
                  </div>
                  <div class="flex-shrink-1 bg-light rounded py-2 px-3 ml-3">
                    <div class="font-weight-bold mb-1">Sharon Lessman</div>
                    Sit meis deleniti eu, pri vidit meliore docendi ut, an eum
                    erat animal commodo.
                  </div>
                </div>
              </div>
            </div>

            <div class="flex-grow-0 py-3 px-4 border-top">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Mesajınızı yazın"
                />
                <button class="btn btn-info text-white">
                  <i class="fas fa-paper-plane"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Kullanicilar from "@/components/Pages/Mesajlar/Kullanicilar.vue";
export default {
  components: { Kullanicilar },
};
</script>

<style>
#border {
  border: 0;
  border-right: 1px solid #0dcaf0;
}
</style>
